import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { NgClass } from "@angular/common";
import { DateDrillDownSelectorComponent } from "./components/date-drill-down-selector/date-drill-down-selector.component";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-date-drill-down",
    templateUrl: "./date-drill-down.component.html",
    styleUrls: ["./date-drill-down.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        DateDrillDownSelectorComponent,
        TranslatePipe
    ]
})
export class DateDrillDownComponent {

  @Input() periodFrom: any;
  @Input() periodTom: any;
  @Input() parent: any;

  showDateDrilldownPicker = false;

  onDateSelected(param: any) {
      if (param.item !== undefined) {
          this.parent.onDateSelected(param.item);
      }
  }

  toggleDateDrilldownPicker() {
      this.showDateDrilldownPicker = !this.showDateDrilldownPicker;
  }
}
